import type { ReactNode } from 'react'
import type { RenderElementProps } from 'slate-react'
import { Mention } from 'shared/components/editor/mention'
import type { CustomElement } from 'modules/community/types/custom-editor'
import type { CustomRenderLinkProps } from './Link/link'
import Link from './Link/link'

export interface CustomRenderElementProps extends RenderElementProps {
  element: CustomElement
}

export const Element = (props: CustomRenderElementProps): ReactNode => {
  const { attributes, children, element } = props

  switch (element.type) {
    case 'link': {
      return <Link {...(props as CustomRenderLinkProps)} />
    }
    case 'mention': {
      return (
        <Mention attributes={attributes} element={element}>
          {children}
        </Mention>
      )
    }
    default: {
      return (
        <p className="relative" {...attributes}>
          {children}
        </p>
      )
    }
  }
}
